import _ from 'lodash'
import Vue from 'vue'
import StringFormat from '@/utils/StringFormat'
import ApiManager from '@/utils/ApiManager'
import TheSideConfig from '@/utils/TheSideConfig'
import Constants from '@/utils/Constants'
import axios from 'axios'
import router from '@/router'
// import { stat } from 'fs'
import VueJwtDecode from 'vue-jwt-decode'
import { isStoreAnalysis } from '@/utils/business'
import { getApps, initializeApp } from 'firebase/app'

const state = {
  loadingNews: true,
  newsItems: [],
  loadingSupport: false,

  token: null,
  user: {},
  contract: [],
  pos_date: null,
  site: [],
  firebase: {},
  pageNames: [],
  menu: {},
  analyze_targets: {},
  message: {
    content: '',
    type: ''
  },
  password_invalid: false,
  // 多要素認証が必要かどうか
  mfa_needed: false
}

const getters = {
  getToken: state => state.token,
  getUserByKey: (state) => (key) => {
    if (key in state.user) {
      return state.user[key]
    }
    return null
  },
  getContractByKey: (state) => (key) => {
    if (key in state.contract) {
      return state.contract[key]
    }
    return null
  },
  getFirebaseByKey: (state) => (key) => {
    if (key in state.firebase) {
      return state.firebase[key]
    }
    return null
  },
  getPosDate: (state) => state.pos_date,
  getSiteByKey: (state) => (key) => {
    if (key in state.site) {
      return state.site[key]
    }
    return null
  },
  getPageNameByType: (state) => (type) => {
    if (type in state.pageNames) {
      return state.pageNames[type]
    }
    return null
  },
  getAnalyzeTargetByCode: (state) => (code) => {
    if (code in state.analyze_targets) {
      return state.analyze_targets[code]
    }
    return null
  },
  getCategoryRankName: (state) => () => {
    if (state.site.product_category_rank_name) {
      return state.site.product_category_rank_name
    }
    return [
      '',
      'カテゴリを選択',
      'カテゴリを選択',
      'カテゴリを選択',
      'カテゴリを選択',
      'カテゴリを選択',
      'カテゴリを選択',
      'カテゴリを選択',
      'カテゴリを選択',
      'カテゴリを選択',
      'カテゴリを選択'
    ]
  },
  getShopCategoryRankName: (state) => () => {
    if (state.site.shop_category_rank_name) {
      return state.site.shop_category_rank_name
    }
    return [
      '',
      'カテゴリを選択',
      'カテゴリを選択',
      'カテゴリを選択',
      'カテゴリを選択',
      'カテゴリを選択',
      'カテゴリを選択',
      'カテゴリを選択',
      'カテゴリを選択',
      'カテゴリを選択',
      'カテゴリを選択'
    ]
  }
}

// Firebaseの初期化
const initializeFirebase = () => {
  if (getApps().length === 0) {
    console.log('firebase initialize')
    initializeApp({
      'apiKey': Constants.getFirebase('apiKey'),
      'authDomain': Constants.getFirebase('authDomain'),
      'databaseURL': Constants.getFirebase('databaseURL'),
      'projectId': Constants.getFirebase('projectId'),
      'storageBucket': Constants.getFirebase('storageBucket'),
      'messagingSenderId': Constants.getFirebase('messagingSenderId'),
      'publicKey': Constants.getFirebase('publicKey')
    })
  }
}

const actions = {
  async getNoLoginSite ({ state, commit }) {
    const response = await ApiManager.request('Site').site()
    if (response) {
      commit('setNoLoginSite', response.data)
    }
  },
  /**
   * お知らせデータ取得
   */
  async getNewsData ({ commit }) {
    commit('setNewsLoading', true)
    const response = await ApiManager.request('Notice').noticePublic()
    if (response) {
      commit('setNews', response.data)
    }
  },
  /**
   * vueがロードされるときに最初に呼ぶチェック
   */
  async check ({ commit }, payload) {
    //  取り急ぎtokenだけでチェック
    //  todo: そのうちsiteの認証版みたいなのを呼ぶ
    if (Vue.localStorage.get('token')) {
      commit('setInfo')
    } else {
      this.dispatch('account/initInfo')
    }
  },
  /**
   * ログイン
   */
  async login ({ commit }, payload) {
    const response = await ApiManager.request('Login').login(payload)
    let type = 'success'
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      //  siteなどの情報をセット
      this.dispatch('account/setLoginInfo', response.data.data)
      // firebaseの初期化
      initializeFirebase()
      commit('setPasswordInvalid', response.data.meta.password_invalid)
      commit('setMfaNeeded', response.data.meta.mfa_needed)
      commit('setMessage', { type: type })
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
      commit('setMessage', { content: response.data.data.message, type: type })
    }
    return response
  },
  /**
   * ログアウト
   */
  async logout ({ commit }, callback) {
    this.dispatch('loading/loadingPagePlus')
    const response = await ApiManager.request('Logout').logout()
    if (response.data.code === 200000) {
      this.dispatch('loading/loadingPageMinus')
      console.log('logout api success')
      this.dispatch('loading/loadingPageMinus')
      this.dispatch('account/initInfo')
      callback()
    } else {
      this.dispatch('loading/loadingPageMinus')
      console.log('logout api error')
    }
  },
  /**
   * registration_token更新
   */
  async updateToken ({ commit }, payload) {
    await ApiManager.request('User').userRegistrationToken(payload)
  },
  /**
   * 2要素認証フラグ更新
   */
  async updateMfa ({ commit }, payload) {
    const response = await ApiManager.request('User').userMfa(payload)
    if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      commit('setMessage', { content: response.data.data.message, type: 'error' })
    }
  },
  /**
   * ログイン情報を初期化
   */
  initInfo ({ commit }, info) {
    console.log('ログイン情報初期化')
    Vue.localStorage.remove('token')
    Vue.localStorage.remove('user')
    Vue.localStorage.remove('contract')
    Vue.localStorage.remove('menu')
    Vue.localStorage.remove('site')
    Vue.localStorage.remove('firebase')
    Vue.localStorage.remove('pos_date')
    Vue.localStorage.remove('analyze_targets')
    Vue.localStorage.remove('analyze')
    Vue.localStorage.remove('registration_token_sent_to_server')
    Vue.localStorage.remove('groupMode')
    commit('setInfo')
  },
  /**
   * ログイン情報をセット
   */
  setLoginInfo ({ commit }, info) {
    console.log('ログイン情報セット')
    Vue.localStorage.set('token', info.access_token)
    Vue.localStorage.set('user', JSON.stringify(info.user))
    Vue.localStorage.set('contract', JSON.stringify(info.contract))
    Vue.localStorage.set('menu', JSON.stringify(info.menu))
    Vue.localStorage.set('site', JSON.stringify(info.site))
    Vue.localStorage.set('firebase', JSON.stringify(info.firebase))
    Vue.localStorage.set('pos_date', JSON.stringify(info.pos_date))
    Vue.localStorage.set('analyze_targets', JSON.stringify(info.analyze_targets))
    commit('setInfo')
  },
  /**
   * ローカルストレージにあるuserの情報を更新する
   */
  updateLocalUser ({ commit }, user) {
    let localUser = JSON.parse(Vue.localStorage.get('user'))
    localUser.info_flag = parseInt(user.infoFlag)
    localUser.wait_flag = parseInt(user.waitFlag)
    Vue.localStorage.set('user', JSON.stringify(localUser))
    commit('setLocalUser', localUser)
  },
  async refreshToken ({ commit }) {
    const payload = {
      token: Vue.localStorage.get('token')
    }
    if (!payload.token) return
    let config = {
      baseURL: Constants['apiEndPoint']
    }
    await axios.post('/auth/refresh_token', payload, config)
      .then((response) => {
        commit('setToken', response.data.token)
      })
      .catch((error) => {
        Vue.localStorage.remove('token')
        console.log('トークンリフレッシュエラー：' + error)
        // router.push({ path: '/login' })
      })
  },
  async inspectToken (state, serverTime) {
    // return true
    const token = Vue.localStorage.get('token')
    if (token) {
      const decoded = VueJwtDecode.decode(token)
      const exp = decoded.exp
      const origIat = decoded.orig_iat
      console.log(`Token Inspect: server_time=${serverTime}, token_decoded=${JSON.stringify(decoded)}`)
      // expiring in 30 minutes, maximum lifespan of 7 days
      // 30minutes = 1800seconds
      // 7days - 30minuties = 604800–1800 = 603000
      // 有効時間まで3分以内のトークンのみ刷新する
      if (exp - (serverTime / 1000) < 180 && (serverTime / 1000) - origIat < 603000) {
        console.log('Token Inspect: token refresh')
        this.dispatch('account/refreshToken')
      } else if (parseInt((exp - (serverTime / 1000)) / 60) <= 30) {
        // DO NOTHING, DO NOT REFRESH
        console.log('Token Inspect: token safe')
      } else {
        console.log(`Token Inspect: the token has expired, redirected to the login page, exp=${exp}s, serverTime=${serverTime / 1000}s`)
        Vue.localStorage.remove('token')
        // 強制ログイン、JWT_REFRESH_EXPIRATION_DELTA過ぎ
        router.push({ path: '/login' })
      }
    }
  },
  setPasswordInvalid ({ commit }, passwordInvalid) {
    commit('setPasswordInvalid', passwordInvalid)
  }
}

const mutations = {
  setNoLoginSite (state, data) {
    //  site情報map化
    if (data.data) {
      let siteNew = {}
      for (let i = 0; i < data.data.length; i++) {
        siteNew[data.data[i].key] = data.data[i].value
      }
      state.site = siteNew
    } else {
      state.site = []
    }
  },
  setNewsLoading (state, data) {
    state.loadingNews = data
  },
  setNews (state, data) {
    for (let i = 0; i < data.data.length; i++) {
      data.data[i].display_from = StringFormat.ymdhmFormat(data.data[i].display_from)
    }
    state.newsItems = data.data
    state.loadingNews = false
  },
  setMessage (state, data) {
    state.message = data
  },
  setInfo (state) {
    let lsdata = {}
    lsdata.access_token = Vue.localStorage.get('token')

    lsdata.firebase = JSON.parse(Vue.localStorage.get('firebase'))
    Vue.localStorage.remove('firebase')
    lsdata.user = JSON.parse(Vue.localStorage.get('user'))
    if (lsdata.access_token) {
      lsdata.contract = JSON.parse(Vue.localStorage.get('contract'))
      lsdata.menu = JSON.parse(Vue.localStorage.get('menu'))
      lsdata.site = JSON.parse(Vue.localStorage.get('site'))
      lsdata.pos_date = JSON.parse(Vue.localStorage.get('pos_date'))
      lsdata.analyze_targets = JSON.parse(Vue.localStorage.get('analyze_targets'))

      state.token = lsdata.access_token
      state.user = lsdata.user
      state.contract = lsdata.contract
      state.firebase = lsdata.firebase
      state.pos_date = lsdata.pos_date

      //  site情報map化
      if (lsdata.site) {
        let siteNew = {}
        for (let i = 0; i < lsdata.site.length; i++) {
          let value = lsdata.site[i].value
          let key = lsdata.site[i].key

          if (key === 'card_kind' || key === 'payment_method' || key === 'rank_definision') {
            //  UIのselect用配列にする
            const data = JSON.parse(value)
            let newAry = []
            if (key === 'rank_definision') {
              newAry.push({
                text: '設定なし',
                value: 0
              })
              _.forEach(data, (v, k) => {
                newAry.push(
                  {
                    text: v,
                    value: k - 0
                  }
                )
              })
            } else {
              if (key === 'payment_method') {
                newAry.push({
                  text: '設定なし',
                  value: 0
                })
              }
              _.forEach(data, (v, k) => {
                newAry.push(
                  {
                    text: v,
                    value: k - 0
                  }
                )
              })
            }
            siteNew[key] = newAry
          } else if (key === 'product_category_rank_name' || key === 'shop_category_rank_name') {
            //  通常配列へ
            const data = JSON.parse(value)
            let newAry = []
            _.forEach(data, (v, k) => {
              const index = k - 0
              newAry[index] = v
            })
            siteNew[key] = newAry
          } else {
            siteNew[key] = value
          }
        }
        state.site = siteNew
      } else {
        state.site = []
      }
      console.log('site to map', state.site)

      //  ページタイトルmap化
      let lsMenus = []
      if (lsdata.menu) {
        for (let i = 0; i < lsdata.menu.length; i++) {
          if (!isStoreAnalysis()) {
            // ※メニュー自体非表示とする: デシル分析, ランク分析, 店舗グループ
            const excluded = ['IF00027', 'IF00028', 'GR00005']
            if (_.includes(excluded, lsdata.menu[i].code)) {
              continue
            }
          }
          lsMenus.push(lsdata.menu[i])
          state.pageNames[lsdata.menu[i].code] = lsdata.menu[i].name
        }
      } else {
        state.pageNames = []
      }

      //  menu作成
      if (lsMenus) {
        const menuOrg = TheSideConfig.configs.menus
        let menuNew = _.cloneDeep(menuOrg)

        for (let i = 0; i < menuOrg.length; i++) {
          let child = menuOrg[i].children
          let newChild = []
          for (let c = 0; c < child.length; c++) {
            const code = child[c].code
            const number = child[c].number
            lsMenus.some((m) => {
              if (m.code === code) {
                m.prefix = number + '.'
                newChild.push(m)
                return true
              } else {
                return false
              }
            })
          }
          menuNew[i].children = newChild
        }
        state.menu = menuNew
      }

      if (lsdata.analyze_targets) {
        for (let i = 0; i < lsdata.analyze_targets.length; i++) {
          state.analyze_targets[lsdata.analyze_targets[i].code] = lsdata.analyze_targets[i]
        }
      } else {
        state.analyze_targets = {}
      }
    } else {
      state.token = null
      state.user = lsdata.user || {}
      state.contract = []
      state.pos_date = null
      state.firebase = lsdata.firebase || {}
      state.pageNames = []
      state.menu = {}
      state.analyze_targets = {}
    }
  },
  setLocalUser (state, user) {
    state.user = user
  },
  setPageName (state, code) {
    const menu = JSON.parse(Vue.localStorage.get('menu'))
    if (menu) {
      for (let i = 0; i < menu.length; i++) {
        if (menu[i].code === code) {
          state.pageName = menu[i].name
          break
        }
      }
    } else {
      state.pageName = ''
    }
  },
  setSite (state) {
    const site = JSON.parse(Vue.localStorage.get('site'))
    if (site) {
      let siteNew = {}
      for (let i = 0; i < site.length; i++) {
        siteNew[site[i].key] = site[i].value
      }
      state.site = siteNew
    } else {
      state.site = {}
    }
  },
  setToken (state, data) {
    state.token = data
    Vue.localStorage.set('token', data)
  },
  /**
   * パスワード期限きれ設定
   */
  setPasswordInvalid (state, passwordInvalid) {
    state.password_invalid = passwordInvalid
  },
  setMfaNeeded (state, mfaNeeded) {
    state.mfa_needed = mfaNeeded
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
